import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://video-player-by-tahmid.herokuapp.com",
});

export default axiosInstance;
